import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CURRICULUM } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/curriculum/new")({
  component: () => <DeptContentForm cfg={CURRICULUM} />,
});
